export const getAccessToken = () => localStorage.getItem('accessToken');
export const saveToken = (token) => localStorage.setItem('accessToken', token);
export const clearSession = () => localStorage.removeItem('accessToken');

export const getSessionId = () => localStorage.getItem('sessionId');
export const saveSessionId = (sessionId) => localStorage.setItem('sessionId', sessionId);
export const clearSessionId = () => localStorage.removeItem('sessionId');

